import React, { useState } from 'react'
import clsx from 'clsx'
import 'react-toastify/dist/ReactToastify.css'
import Icon from '../Icon/Icon'
import Button from '../Button'
import { toast } from 'react-toastify'

function encode(data) {
  const formData = new FormData()
  for (const key of Object.keys(data)) {
    formData.append(key, data[key])
  }
  return formData
}

export const ToastCheckboxes = ({
  otherClasses,
  toastLabel,
  state,
  formName,
  handleCleanup,
}) => {
  const toastMessageClasses = clsx(
    otherClasses,
    'flex justify-between items-start gap-5 flex-col w-full lg:max-w-4/5 px-4 py-14 lg:px-10'
  )

  const [optIns, setOptIns] = useState({
    legislationRead: false,
    // notificationsAccepted: false,
  })

  const handleChange = (e) => {
    setOptIns({
      ...optIns,
      [e.target.name]: e.target.checked,
    })
  }

  const handleSubmitButton = async () => {
    const body = {
      ...state,
      ...optIns,
    }
    try {
      await fetch('/', {
        method: 'POST',
        body: encode({
          'form-name': formName,
          ...body,
        }),
      })
      handleCleanup()
    } catch (error) {
      console.error(error)
    }
    handleCleanup()
    toast.dismiss()
  }
  return (
    <div className={toastMessageClasses} data-testid="toast-message">
      <div className="grid grid-cols-[50px_1fr]  items-center gap-2">
        <Icon icon="error-page-icon" iconHeight={40} iconWidth={40} />
        <p className="font-work-sans text-white font-normal text-base leading-6">
          {toastLabel}
        </p>
      </div>
      {/* <div className="grid grid-cols-[50px_1fr] items-start gap-2 ">
        <input
          type="checkbox"
          checked={state.notificationsAccepted}
          name="notificationsAccepted"
          onChange={(e) => handleChange(e)}
        />
        <p className="font-work-sans text-white font-normal text-base leading-6">
          I would like to receive SMS/MMS notification through my phone.
        </p>
      </div> */}
      <div className="grid grid-cols-[50px_1fr] items-start gap-2 ">
        <input
          type="checkbox"
          checked={state.legislationRead}
          name="legislationRead"
          onChange={handleChange}
        />
        <p className="font-work-sans text-white font-normal text-base leading-6">
          In accordance with Canadian Anti-Spam Legislation, I have read All
          Access Home's Privacy Policy and give my consent to receive electronic
          communications from All Access Homes regarding; communitties of
          potential interest, news, events, promotions and other related
          subjects.
        </p>
      </div>
      <Button
        variant="primary"
        label="Submit"
        otherClasses="!w-fit mx-[50px]"
        onClick={handleSubmitButton}
      />
    </div>
  )
}

export default ToastCheckboxes
